import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ResidueCollectedForm from '../Forms/ResidueCollectedForm';

const ResidueCollectedModal = ({
	dataResidueCollected,
	isOpen,
	isEdit,
	handleToggleModal,
	residuesCollectedList,
	handleResiduesCollectedList
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Residuo Recolectado
			</ModalHeader>

			<ResidueCollectedForm
				dataResidueCollected={dataResidueCollected}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				residuesCollectedList={residuesCollectedList}
				handleResiduesCollectedList={handleResiduesCollectedList}
			/>
		</Modal>
	);
};

export default ResidueCollectedModal;